// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"1c2d202d","453":"ef156bce"}[chunkId] + ".chunk.js";
};